/**
 * Shared TanStack Form contexts for the app-wide bound field components.
 * Aliases: form field context, app form context, tanstack field context.
 */
import { createFormHookContexts } from "@tanstack/react-form";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();
